import { logDOM } from "@testing-library/react";
import api from "../../utils/axios-util";
import Middleware from "../../utils/api-middleware"

export const fetch_meetings = (query) => {
    let filter = "";
    if (query.filter) {
        filter += '&filter=' + query.filter;
    }
    if (query.meetingID !== undefined) {
        filter = '&meetingID=' + query.meetingID;
    }
    if (query.module !== undefined) {
        filter += '&module=' + query.module;
    }
    if (query.phone_number !== undefined) {
        filter += '&phone_number=' + query.phone_number;
    }
    if (query.status !== undefined) {
        filter += '&status=' + query.status;
    }
    filter += `&campaign=${query.campaign}`
    let dateFilter = ""
    if (query.fromDate != undefined && query.toDate != undefined) {
        dateFilter = `&fromDate=${query.fromDate}&toDate=${query.toDate}`
    }

    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .get(`/asterdialer/meetings?userID=${query.userID}${filter}&take=${query.take}&skip=${query.skip}${dateFilter}`)
                .then((response) => {
                    let res = Middleware("Meetings", "fetch", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("Meetings", "fetch", err.response.data, "catch")
                    reject(res);
                });
        });
    }
};

export const editMeeting = (query, payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .put(`/meetings/update/${query}`, payload)
                .then((response) => {
                    let res = Middleware("Meetings", "update", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("Meetings", "update", err.response.data, "catch")
                    reject(res);
                });
        });
    }

};
export const create_meeting = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .post(`/asterdialer/meeting/schedule`, payload)
                .then((response) => {
                    let res = Middleware("Meetings", "create", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("Meetings", "create", err.response.data, "catch")
                    reject(res);
                });
        });
    }

};
export const Reassign_User = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .post(`/action/event`, payload)
                .then((response) => {
                    let res = Middleware("Meetings", "fetch", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("Meetings", "fetch", err.response.data, "catch")
                    reject(res);
                });
        });
    }

};
export const suduledMeetings = (query) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api.get(`/asterdialer/meetings/condition?user=${query.agent}&meetingDate=${query.meetingDate}&meeting_status=${query.meeting_status}&base=agent&meeting_id=${query.meeting_id}`)
                .then((response) => {
                    let res = Middleware("Meetings", "fetch", response)
                    if (res.statusCode === 204 || res.statusCode === 200) {
                        resolve(res)
                    } else {
                        reject(res)
                    }
                }).catch((err) => {
                    let res = Middleware("Meetings", "fetch", err.response.data, "catch")
                    reject(res);
                })
        })
    }
}
export const Meetingtitle = () => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .get(`/title/fetch?is_active=1&module=meeting`)
                .then((response) => {
                    let res = Middleware("Meetings", "fetch", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("Meetings", "fetch", err.response.data, "catch")
                    reject(res);
                });
        });
    }

};